import { createViewFilesList } from "@/ui/views/ViewFilesList";
import type { TViewFilesListParams } from "@/ui/views/ViewFilesList";

/**
 * View parameters (injected dependencies)
 */
export type TViewFilesFinJournalsParams = TViewFilesListParams;

/**
 * View props (from router/parent)
 */
export type TViewFilesFinJournalsProps = Record<string, never>;

/**
 * Creates the FinJournals Files list view component (filtered to show only FinJournals files).
 */
export const createViewFilesFinJournals = ({ useCases }: TViewFilesFinJournalsParams) =>
    createViewFilesList({
        title: "FinJournals",
        description: "Financial Journals files",
        errorTitle: "Failed to load files",
        emptyTitle: "No FinJournals yet",
        emptyDescription: "Upload your first Financial Journals file to get started.",
        hiddenColumns: ["serviceProviderName", "dealName", "fileType"],
    })({ useCases });
